import script from "./Test-ChoiceQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./Test-ChoiceQuestions.vue?vue&type=script&setup=true&lang=js"

import "./Test-ChoiceQuestions.vue?vue&type=style&index=0&id=fc8e34e6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc8e34e6"]])

export default __exports__